import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import { useMemo } from 'react';

import DropdownArrowIcon from './DropdownArrowIcon';

interface Props {
    options?: {value: string, label: string}[];
    placeholder?: string;
    listTitle: string;
    onChange?: (v: string) =>void;
    value?: string;
}

type OptionListProps = Pick<Props, 'options' | 'value' | 'onChange'>;

function Dropdown({
    options, placeholder, listTitle, onChange, value,
}:Props) {
    const displayValue = useMemo<string|undefined>(() => {
        if (value) {
            return options?.find((option) => option.value === value)?.label;
        }
        return undefined;
    }, [options, value]);
    const { openBottomSheet } = useBottomSheet();

    const handleClick = () => {
        openBottomSheet(
            listTitle,
            <OptionList options={options}
                value={value}
                onChange={onChange} />,
        );
    };
    return (
        <Button onClick={handleClick}
            type='button'>
            {displayValue ? (
                <Text>{displayValue}</Text>
            ) : (
                <Text color={colors.gray5}>
                    {placeholder}
                </Text>
            )}
            <DropdownArrowIcon/>
        </Button>
    );
}

function OptionList({ options, value, onChange }:OptionListProps) {
    const { closeBottomSheet } = useBottomSheet();
    return <List spacing={18}>
        {options?.map((option) => (
            <Radio key={option.value}
                isSelected={value === option.value}
                value={option.value}
                onChange={() => {
                    onChange?.(option.value);
                    closeBottomSheet();
                }}>
                {option.label}
            </Radio>
        ))}
    </List>;
}

const Button = styled.button`
    align-items: center;
    background-color: var(--color-gray1);
    border: 1px solid var(--color-gray4);
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    width: 100%;
`;

const List = styled(Column)`
    padding: 24px 20px 64px;
`;

export default Dropdown;
